import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, CheckCircle2Icon, CalendarIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ResourcesPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-1263">
      {/* SECȚIUNEA 1 — HERO RESURSE GRATUITE */}
      <section className="bg-brand-beige section-padding" data-id="element-1264">
        <div className="container-custom" data-id="element-1265">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-1266">
            <div className="max-w-xl" data-id="element-1267">
              <h1 className="font-playfair text-[40px] md:text-[56px] font-bold text-brand-navy mb-6 leading-[1.1]" data-id="element-1268">
                Resurse gratuite pentru dezvoltarea copilului tău
              </h1>
              <p className="font-source text-[18px] text-brand-textSecondary mb-8" data-id="element-1269">
                Începe cu pași simpli și practici ca să înțelegi unde e copilul
                tău, ce are nevoie acum și cum îl poți ajuta acasă, prin joc și
                conectare, fără tehnici complicate.
              </p>
              <a href="#download-form" className="btn-primary inline-flex items-center justify-center gap-2" data-id="element-1270">
                <DownloadIcon size={20} data-id="element-1271" />
                Descarcă Ghidul Gratuit
              </a>
            </div>
            <div className="relative rounded-[24px] overflow-hidden shadow-2xl" data-id="element-1272">
              <img src="https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=800&q=80" alt="Mamă și copil citind" className="w-full h-full object-cover aspect-[4/3]" data-id="element-1273" />
              <div className="absolute inset-0 bg-brand-navy/10" data-id="element-1274"></div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — PROBLEMĂ (AGITARE) */}
      <section className="bg-brand-ivory section-padding" data-id="element-1275">
        <div className="container-custom" data-id="element-1276">
          <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-[24px] shadow-sm border border-gray-100 text-center" data-id="element-1277">
            <h2 className="font-playfair text-[28px] md:text-[36px] font-bold text-brand-navy mb-6" data-id="element-1278">
              Ce se întâmplă când cauți răspunsuri peste tot și nu găsești un
              plan clar?
            </h2>
            <div className="font-source text-[16px] md:text-[18px] text-brand-text space-y-4 mb-8 text-left" data-id="element-1279">
              <p data-id="element-1280">
                Dimineața te trezești și te uiți la copilul tău. Nu vorbește sau
                spune doar câteva cuvinte. Ieri ai citit ceva pe un grup de
                Facebook care te-a speriat. Alaltăieri ai descărcat un ghid
                gratuit care nu ți-a spus nimic concret. Soțul crede că
                exagerezi, soacra îți spune că "și tatăl lui a vorbit târziu".
              </p>
              <p data-id="element-1281">
                Dacă continui să cauți la întâmplare, pierzi luni în care ai fi
                putut face diferența. Fiecare lună contează la această vârstă,
                iar informațiile trunchiate nu înlocuiesc un plan clar.
              </p>
              <p className="font-bold text-brand-navy" data-id="element-1282">
                Aceste resurse gratuite sunt primul pas: îți dau claritate, îți
                arată ce e normal și ce nu, și îți oferă primele lucruri
                concrete pe care le poți face acasă, chiar de azi.
              </p>
            </div>
            <a href="#download-form" className="btn-primary inline-flex items-center gap-2" data-id="element-1283">
              <DownloadIcon size={20} data-id="element-1284" />
              Descarcă Ghidul Gratuit
            </a>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — RESURSA #1 */}
      <section id="download-form" className="bg-brand-navy section-padding text-white" data-id="element-1285">
        <div className="container-custom" data-id="element-1286">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-1287">
            <div className="relative rounded-[24px] overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-1288">
              <img src="https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=800&q=80" alt="Ghid Dezvoltare" className="w-full h-full object-cover aspect-[4/3]" data-id="element-1289" />
            </div>
            <div className="space-y-6" data-id="element-1290">
              <span className="inline-block px-4 py-1.5 rounded-full bg-brand-gold/20 text-brand-gold font-montserrat font-bold text-[12px] tracking-wider uppercase" data-id="element-1291">
                eBOOK GRATUIT
              </span>
              <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white leading-tight" data-id="element-1292">
                Dezvoltarea 0-2 ani: Ghid de orientare pentru mame
              </h2>
              <p className="font-source text-[18px] text-white/80" data-id="element-1293">
                Un ghid practic care te ajută să înțelegi cum se dezvoltă
                copilul tău, ce e normal, ce necesită atenție și când e nevoie
                de o evaluare profesională. Scris pe înțelesul mamelor, nu în
                jargon clinic.
              </p>

              <div className="bg-white/5 rounded-[16px] p-6 border border-white/10" data-id="element-1294">
                <h3 className="font-montserrat font-bold text-[16px] text-brand-gold mb-4" data-id="element-1295">
                  CE PRIMEȘTI ÎN eBOOK:
                </h3>
                <ul className="space-y-3" data-id="element-1296">
                  {['Ce ar trebui să facă copilul tău la fiecare vârstă, pe fiecare arie de dezvoltare', 'Diferența clară dintre o variație normală și o întârziere care necesită atenție', 'Semnele de alarmă pe care merită să le cunoști, fără să te panichezi', 'Când e suficient să observi și când e nevoie de o evaluare profesională', 'Primele lucruri concrete pe care le poți face acasă, chiar de azi'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1297">
                      <CheckCircle2Icon className="text-brand-gold flex-shrink-0 mt-0.5" size={20} data-id="element-1298" />
                      <span className="font-source text-[15px] text-white/90" data-id="element-1299">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="pt-4" data-id="element-1300">
                <button className="btn-inverted w-full sm:w-auto flex items-center justify-center gap-2" data-id="element-1301">
                  <DownloadIcon size={20} data-id="element-1302" />
                  Descarcă Ghidul Gratuit
                </button>
                <p className="font-source text-[13px] text-white/60 mt-3 text-center sm:text-left" data-id="element-1303">
                  Îl primești imediat pe email. Gratuit, fără condiții.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — BENEFICII RESURSE */}
      <section className="bg-brand-beige section-padding" data-id="element-1304">
        <div className="container-custom" data-id="element-1305">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-1306">
            Ce se schimbă după ce parcurgi aceste resurse
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1307">
            {[{
            title: 'Claritate reală',
            desc: 'Înțelegi ce e normal și ce nu la vârsta copilului tău, fără să te mai bazezi pe păreri de pe internet.'
          }, {
            title: 'Primii pași concreți',
            desc: 'Știi exact ce poți face acasă, chiar de azi, fără jucării scumpe și fără tehnici complicate.'
          }, {
            title: 'Liniște interioară',
            desc: 'Nu te mai sperii de fiecare articol citit pe internet. Ai un reper clar pe care te poți baza.'
          }, {
            title: 'Încredere ca mamă',
            desc: 'Nu mai aștepți validare de la apropiați. Știi ce faci și de ce, pentru că ai informația corectă.'
          }].map((card, i) => <div key={i} className="bg-white p-6 rounded-[16px] shadow-sm border-t-4 border-brand-coral" data-id="element-1308">
                <h3 className="font-montserrat font-bold text-[18px] text-brand-navy mb-3" data-id="element-1309">
                  {card.title}
                </h3>
                <p className="font-source text-[15px] text-brand-text" data-id="element-1310">
                  {card.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 5 — RESURSA #2 */}
      <section className="bg-brand-ivory section-padding" data-id="element-1311">
        <div className="container-custom" data-id="element-1312">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1313">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-coral/10 text-brand-coral font-montserrat font-bold text-[12px] tracking-wider uppercase mb-4" data-id="element-1314">
              eBOOK GRATUIT NR. 2
            </span>
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy mb-4" data-id="element-1315">
              Ce să lucrez acasă fără să stric lucrurile
            </h2>
            <p className="font-source text-[18px] text-brand-textSecondary" data-id="element-1316">
              Alege ghidul care ți se potrivește și începe cu tema care te
              preocupă acum.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1317">
            <div className="bg-white p-8 rounded-[24px] shadow-card border border-gray-100 flex flex-col" data-id="element-1318">
              <h3 className="font-playfair font-bold text-[24px] text-brand-navy mb-4" data-id="element-1319">
                Dezvoltarea 0-2 ani - Ghid de orientare
              </h3>
              <p className="font-source text-[16px] text-brand-text mb-8 flex-grow" data-id="element-1320">
                Te ajută să știi când e suficient să observi și când e nevoie de
                o evaluare profesională. Ideal dacă ai un copil mic și nu ești
                sigură dacă dezvoltarea lui e în parametri normali.
              </p>
              <button className="btn-secondary w-full flex items-center justify-center gap-2" data-id="element-1321">
                <DownloadIcon size={20} data-id="element-1322" />
                Descarcă Ghidul Gratuit
              </button>
            </div>
            <div className="bg-white p-8 rounded-[24px] shadow-card border border-gray-100 flex flex-col" data-id="element-1323">
              <h3 className="font-playfair font-bold text-[24px] text-brand-navy mb-4" data-id="element-1324">
                Ce să lucrez acasă fără să stric lucrurile
              </h3>
              <p className="font-source text-[16px] text-brand-text mb-8 flex-grow" data-id="element-1325">
                Idei practice de lucru cu copilul acasă, ca să faci progrese
                reale fără să greșești din lipsă de informație. Potrivit pentru
                mame care vor să ajute dar nu știu de unde să înceapă.
              </p>
              <button className="btn-secondary w-full flex items-center justify-center gap-2" data-id="element-1326">
                <DownloadIcon size={20} data-id="element-1327" />
                Descarcă Ghidul Gratuit
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA WORKSHOP */}
      <section className="bg-brand-beige section-padding" data-id="element-1328">
        <div className="container-custom" data-id="element-1329">
          <div className="max-w-4xl mx-auto bg-white rounded-[24px] shadow-sm border border-gray-100 overflow-hidden" data-id="element-1330">
            <div className="grid md:grid-cols-2" data-id="element-1331">
              <div className="relative h-[300px] md:h-auto" data-id="element-1332">
                <img src="https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=800&q=80" alt="Workshop Gratuit" className="absolute inset-0 w-full h-full object-cover" data-id="element-1333" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-1334">
                <span className="inline-block px-4 py-1.5 rounded-full bg-brand-coral/10 text-brand-coral font-montserrat font-bold text-[12px] tracking-wider uppercase mb-4 w-max" data-id="element-1335">
                  Eveniment Live
                </span>
                <h2 className="font-playfair text-[28px] md:text-[32px] font-bold text-brand-navy mb-4" data-id="element-1336">
                  Participă la Workshop-ul Online Gratuit
                </h2>
                <p className="font-source text-[16px] text-brand-text mb-8" data-id="element-1337">
                  Învață în 90 de minute cum să comunici mai bine cu copilul tău
                  și cum să gestionezi crizele de nervi cu calm și încredere.
                </p>
                <Link to="/workshopgratuit" className="btn-primary w-full flex items-center justify-center gap-2" data-id="element-1338">
                  <CalendarIcon size={20} data-id="element-1339" />
                  Rezervă-ți Locul Gratuit
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 6 — CTA FINAL */}
      <section className="bg-brand-navy section-padding text-center text-white" data-id="element-1340">
        <div className="container-custom" data-id="element-1341">
          <div className="max-w-3xl mx-auto" data-id="element-1342">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white mb-6" data-id="element-1343">
              Vrei mai mult decât resurse gratuite?
            </h2>
            <p className="font-source text-[18px] text-white/80 mb-8" data-id="element-1344">
              Dacă ai parcurs aceste materiale și simți că ai nevoie de ghidare
              personalizată pentru copilul tău, ai două opțiuni: poți programa o
              evaluare online în care analizăm împreună unde e copilul tău și ce
              are nevoie acum, sau te poți înscrie direct în Programul CRESC,
              unde îți arăt pas cu pas cum să îl ajuți pe toate ariile
              dezvoltării.
            </p>
            <div className="flex flex-col items-center gap-4" data-id="element-1345">
              <Link to="/cresc" className="btn-inverted" data-id="element-1346">
                Descoperă Programul CRESC
              </Link>
              <Link to="/contact" className="font-source text-[14px] text-brand-gold hover:underline font-medium" data-id="element-1347">
                Sau programează o evaluare online pentru copilul tău.
              </Link>
            </div>
          </div>
        </div>
      </section>
    </motion.div>;
}